export default __webpack_public_path__ + "static/slide4-fd7ebc0fca641cf389d008db2ef3bc0a.png";